import { LiveClassState } from '../../types';
import * as types from './types';

export const setShowClassStartPopup = (payload: LiveClassState) => {
  return {
    type: types.SHOW_CLASS_START_POP_UP,
    payload,
  };
};

export const setCurrentChapterClassDetails = (payload: LiveClassState) => {
  return {
    type: types.SET_CURRENT_CHAPER_DETAILS,
    payload,
  };
};

export const setSelectedChapterPillInfo = (payload: LiveClassState) => {
  return {
    type: types.SET_SELECTED_CHAPTER_PILL_INFO,
    payload,
  };
};

export const setGettingSessionsList = (payload: LiveClassState) => {
  return {
    type: types.SET_GETTING_SESSION_LIST,
    payload,
  };
};

export const setSessionsList = (payload: LiveClassState) => {
  return {
    type: types.SET_SESSION_LIST,
    payload,
  };
};

export const setTeacherDetails = (payload: LiveClassState) => {
  return {
    type: types.GET_TEACHER_DETAILS,
    payload,
  };
};

export const setGettingTeacherDetails = (payload: LiveClassState) => {
  return {
    type: types.GETTING_TEACHER_DETAILS,
    payload,
  };
};

export const setActiveDemoClassSessionId = (payload: LiveClassState) => {
  return {
    type: types.ACTIVE_DEMO_CLASS_SESSION_ID,
    payload,
  };
};
